import { Component, OnInit, ElementRef, AfterViewChecked, SimpleChanges } from '@angular/core';

import { AbstractValueControlBase } from '../../types/abstract-value-control-base';
import { ControlTypeName } from '../../types/control-type-name';
import { TextBoxViewModel } from '../../types/control.types';
import {
  ControlValidatorType,
  ControlValidatorModel,
  RegexValidatorModel,
  ControlValidatorBase
} from '../../types/validator.types';
import { ControlValidatorService } from '../../services/control-validator.service';

@Component({
  selector: 'df-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css']
})
export class EmailComponent extends AbstractValueControlBase<TextBoxViewModel> implements OnInit, AfterViewChecked {
  type: string = ControlTypeName.email;
  isDesign: boolean = false;
  model: TextBoxViewModel;

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.model.placeholder === undefined) {
      this.model.placeholder = '';
    }
  }

  getValidators(controlValidatorService: ControlValidatorService): Array<ControlValidatorBase> {
    if (!this.model.validators) {
      this.model.validators = {};
    }
    // é»è®¤æ·»å ä¸ä¸ªåé¨çemailéªè¯å¨
    const internalRegExpValidatorName = ControlValidatorType.RegularExpressionInternal;
    const regexModel: ControlValidatorModel<RegexValidatorModel> = {
      required: true,
      data: { name: 'email', text: '' }
    };
    this.model.validators[internalRegExpValidatorName] = regexModel;
    const validators = super.getValidators(controlValidatorService);
    return validators;
  }

  ngAfterViewChecked(): void {
    this.handleValueChangeNotByAngularWay();
  }

  valueChange(event: Event) {
    this.validate();
    super.valueChange(event);
  }
}
